var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"positionCapacity"},[_c('div',{staticClass:"tjfx"},[_c('p',[_vm._v("能力素质")]),_c('div',{staticClass:"numberRadius"},[_c('span'),_c('span'),_c('span'),_c('span')])]),_c('div',{staticStyle:{"width":"90%","height":"400px","top":"-60px"},attrs:{"id":"mainQuality"}})])])
}]

export { render, staticRenderFns }